import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { ScheduleGroupClassModal } from '../../components/schedule_group_class';
import User from '../../images/user.jpg';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';
import { ScheduleClassModal } from '../../components/schedule_class_modal'

function LangListScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(true);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [offset, setOffset] = useState(0);
    const [pagination, setPagination] = useState('');
    const location = useLocation();

    useEffect(() => {
        getClasses();
    }, [])

    useEffect(() => {
        getClasses();
    }, [offset])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/classes/fetch_languages.php?offset=' + offset, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setEnrolledClasses(response.data.results);
                setPagination(response.data.pagination);
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

    function changePage(type) {
        if (type == "next") {
            setOffset(offset + 20);
        } else {
            setOffset(offset - 20);
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className="flex flex-wrap justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold">Added Languages</h2>
                    <div className="flex w-full lg:w-auto flex-row lg:flex-col items-center lg:items-end justify-between gap-4 mt-4 md:mt-0">
                        <button onClick={() => navigate('/languages/create-language')} className={`bg-yellow px-6 py-2 rounded-md font-medium text-sm`}>
                            Add New Language
                        </button>
                    </div>
                </div>
                <div className='w-full flex flex-row justify-between'>
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[100%] p-0 lg:p-6 space-y-6 min-h-screen">
                        <div className='overflow-x-auto'>
                            <table className="w-full table-auto border-collapse text-sm">
                                <thead className="bg-gray-50 border-b">
                                <tr>
                                    <th className="p-4">
                                        <div className="flex items-center gap-1">#</div>
                                    </th>
                                    <th className="text-left px-4 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Language</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Status</div>
                                    </th>
                                    <th className="text-left px-2 py-2 font-medium text-gray-600">
                                        <div className="flex items-center gap-1">Time Added</div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="text-gray-700">
                                    {enrolledClasses?.map((row, index) => (
                                        <tr
                                        key={index}
                                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                                        >
                                            <td className="px-4 py-2">
                                                {++index}
                                            </td>
                                            <td className="px-4 py-2 font-semibold">
                                                {row.language}
                                            </td>
                                            <td className="px-2 py-2 font-semibold">
                                                {row.language_status}
                                            </td>
                                            <td className="px-2 py-2">
                                                {row.time}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className='w-full flex justify-end mt-6'>
                                <div className='flex flex-col items-center'>
                                    <div className="flex items-center space-x-2 border border-gray-300 rounded-lg px-1 py-1 w-fit bg-white">
                                        <button
                                            onClick={() => changePage('prev')}
                                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                                        >
                                            Prev.
                                        </button>
                                        <button
                                            onClick={() => changePage('next')}
                                            className="text-sm font-semibold px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
                                        >
                                            Next
                                        </button>
                                    </div> 
                                    <label className='text-sm mt-2'>{pagination}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default LangListScreen;
